import { types } from "../../types/types";

const initialState = {
  accounters: []
}

export const accounterReducer = ( state = initialState, action ) => {
  switch (action.type) {
    
    case types.accounterStartLoading:
      return{
        ...state,
        accounters: [ ...action.payload ]
      }

    default:
      return state;
  }
}
